import { interWbHttp } from '@interco/inter-webview-bridge'

import { TPostResendResponse, TResendOTP, TValidateOTP, TValidateOTPResponse } from './types'

export const postResendOTP = async ({
  authorizationId,
  channel,
}: TResendOTP): Promise<TPostResendResponse> => {
  const endpoint = `/interid/v1/resend-otp`

  const { response } = await interWbHttp.post(endpoint, {
    authorizationId,
    channel,
  })

  const data = JSON.parse(response)
  return data
}

export const postValidateOTP = async ({
  authorizationId,
  token,
}: TValidateOTP): Promise<TValidateOTPResponse> => {
  const endpoint = `/interid/v1/validate-otp`

  const { response } = await interWbHttp.post(endpoint, {
    authorizationId,
    token,
  })
  const data = JSON.parse(response)

  return data
}
